<script setup>
import { onMounted, ref, watchEffect} from 'vue'
import useIsotope from '@/Shared/useIsotope.js'
import Sidebar from './Sidebar.vue'
import News from './News.vue'
import Banners, {BANNERS} from './Banners.vue'

const props = defineProps({
  category: String,
  slug: String,
})

const newsList = ref()
const containerRef = ref()
const isNewsLoaded = ref(false)
const isBannersLoaded = ref(false)

const isotope = (data) => {
  useIsotope({
    isotopeContainer: containerRef.value,
    isotopeItem: '.isotope-item',
    data: data,
    key: 'newsThumb',
  })
}

const onNewsLoaded = (data) => {
  newsList.value = data
  isNewsLoaded.value = true
}

const onBannerLoaded = () => {
  isBannersLoaded.value = true
}

onMounted(() => {
  watchEffect(() => {
    if (isNewsLoaded.value && isBannersLoaded.value) {
      if(newsList.value.length){
        isotope(newsList.value)
      }else{
        isotope(BANNERS)
      }
    }
  })
})

</script>

<template>
  <Sidebar title="関連ニュース">
    <ul ref="containerRef" class="isotope-container pb-[50px] md:pb-[10px]">
      <News :category="props.category" :slug="props.slug" @loaded="onNewsLoaded" />
      <Banners @loaded="onBannerLoaded" />
    </ul>
  </Sidebar>
</template>
